import React from "react";
import {
  BULK_ENTRY,
  CUSTOMER_STATUS_EDIT,
  RISK_MANAGEMENT,
  RISK_MANAGEMENT_LIST,
  SINGLE_ENTRY,
  STATUS_CODE_200,
} from "../../../../utility/constants/valueConstants";
import MainComponent from "../../../components/ui_comps/MainComponent";
import { useDispatch, useSelector } from "react-redux";
import { CustomButton } from "../../../components/main_comps/custom_button";
import { AiOutlinePlus } from "react-icons/ai";
import { colorDarkBlue } from "../../../../utility/constants/colorManager";
import { useState } from "react";
import CustomModal from "../../../components/main_comps/custom_modal";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import CustomUploadField2 from "../../../components/ui_comps/CustomUploadField2";
import {
  Upwardarrow,
  downloadSym,
} from "../../../../utility/constants/assetsManager";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { useSnackbar } from "notistack";
import { validateEmail, validateUpi } from "../../../../utility/emailValidator";
import { formDataPush } from "../clients/client_onboard/ResellerDetails";
import { fullScreenLoadingSlice } from "../../../../data/redux/slice/loaderSlice";
import { API_ENDPOINT } from "../../../../data/network/services/ApiEndpoint";
import { useEffect } from "react";
import { green } from "@mui/material/colors";
import { MainCustomerHeaders } from "../../../../utility/TableHeaders";
import CustomTable from "../../../components/main_comps/custom_table";
import { setHeaders } from "../../../../services/aclValidateServiceTable";
import ResizeListner from "../../../../utility/ResizeListner";
import { fetchCustomerList } from "../../../../services/fetchListingData";
import { useNavigate } from "react-router";
import { showHideFilterModalReducer } from "../../../../data/redux/slice/globalFiltersSlice";
import { FiInfo } from "react-icons/fi";

const RiskManagementIndex = () => {
  const { width, height } = ResizeListner();
  const [openToggleModal, setOpenToggleModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [singleEntry, setSingleEntry] = useState(true);
  const [bulkfile, setbulkfile] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [upi, setUpi] = useState("");
  const [type, setType] = useState("");
  const [openBulkEntryModal, setOpenBulkEntryModal] = useState(false);
  const [successCount, setSuccessCount] = useState("");
  const [failedCount, setFailedCount] = useState("");
  const [failedCustomersArray, setFailedCustomersArray] = useState([]);

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customerListData = useSelector(
    (state) => state.listingSlice.customerList
  );
  const filters = useSelector((state) => state.globalFiltersSlice);
  const aclData = useSelector((state) => state.aclSlice.aclList);

  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234",
  };

  const containerStyle = {
    maxWidth: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px",
  };

  useEffect(() => {
    if (aclData?.includes(RISK_MANAGEMENT_LIST)) {
      dispatch(
        fetchCustomerList({
          page: 0,
          size: 10,
          status: "",
          email: "",
          mobileNumber: "",
          upi: "",
        })
      );
    }
  }, []);

  const onClickSingleEntry = () => {
    ApiRequestPost.singleEntryCustomer({
      customerName: customerName,
      email: email,
      mobileNumber: mobileNumber,
      upi: upi,
      type: type,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          setOpenModal(false);
          setCustomerName("");
          setEmail("");
          setUpi("");
          setMobileNumber("");
          setType("");
          dispatch(
            fetchCustomerList({
              page: 0,
              size: 10,
              status: "",
              email: "",
              mobileNumber: "",
              upi: "",
            })
          );
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };

  const onClickBulkEntry = () => {
    dispatch(fullScreenLoadingSlice(true));
    const excelData = formDataPush({
      "customer-details": bulkfile,
    });
    fetch(API_ENDPOINT.base_url + "risk-svc/api/v1/customer/bulk/entry", {
      body: excelData,
      method: "POST",
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          if (response?.data?.failedCount > 0) {
            setFailedCount(response?.data?.failedCount);
            setSuccessCount(response?.data?.successCount);
            let arr = [];
            arr.push(response?.data?.failedEntries);
            setFailedCustomersArray(arr);
            setOpenBulkEntryModal(true);
          } else {
            enqueueSnackbar(response.message, {
              variant: "success",
            });
            setOpenModal(false);
          }
          dispatch(
            fetchCustomerList({
              page: 0,
              size: 10,
              status: "",
              email: "",
              mobileNumber: "",
              upi: "",
            })
          );
          setbulkfile("");
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally((res) => {
        dispatch(fullScreenLoadingSlice(false));
      });
  };
  useEffect(() => {
    if (aclData?.includes(BULK_ENTRY) && !aclData?.includes(SINGLE_ENTRY)) {
      setSingleEntry(false);
    }
  }, [singleEntry]);

  //function to download sample file in public folder
  const sampleFileDownload = () => {
    const sampleFilepath = "/sampleFile.xlsx";
    const link = document.createElement("a");
    link.href = sampleFilepath;
    link.download = "sample_file.xlsx";
    link.click();
  };

  const onClickChangeStatus = (customerId, status) => {
    ApiRequestPost.updateCustomerStatus({
      customerId: customerId,
      status: status,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          dispatch(
            fetchCustomerList({
              page: 0,
              size: 10,
              status: "",
              email: "",
              mobileNumber: "",
              upi: "",
            })
          );
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };
  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        onClickFilter={() => {
          dispatch(
            showHideFilterModalReducer({
              showFilterModal: true,
              filters: ["upi", "mobileNumber", "email", "customerStatus"],
            })
          );
        }}
        onClickFilterCall={(data) => {
          dispatch(
            fetchCustomerList({
              page: 0,
              size: 10,
              status: data?.status?.value ?? "",
              email: data?.email ?? "",
              mobileNumber: data?.mobileNumber ?? "",
              upi: data?.upi ?? "",
            })
          );
        }}
        filterRequired={true}
        headerTitle="Risk Management"
        customButtonRequired={
          aclData.includes(RISK_MANAGEMENT) &&
          (aclData?.includes(SINGLE_ENTRY) || aclData?.includes(BULK_ENTRY)) ? (
            <CustomButton
              title={"Add Customer"}
              styles={{
                backgroundColor: colorDarkBlue,
                border: "none",
                marginLeft: 10,
              }}
              onClick={() => {
                setOpenModal(true);
              }}
              icon={<AiOutlinePlus color="white" />}
            ></CustomButton>
          ) : null
        }
      />
      {aclData?.includes(RISK_MANAGEMENT_LIST) && (
        <>
          <div style={{ padding: "0px 20px", overflow: "hidden" }}>
            <CustomTable
              styles={{
                maxHeight: height * 0.7,
                minHeight: height * 0.7,
              }}
              data={customerListData?.customers}
              headers={setHeaders(MainCustomerHeaders, aclData)}
              totalElements={customerListData?.totalRecords}
              currentPage={customerListData?.currentPageNo - 1}
              totalPages={customerListData?.totalPages}
              handlePaginate={(page) => {
                dispatch(
                  fetchCustomerList({
                    page: page + 1,
                    size: 10,
                    status: filters?.status?.value ?? "",
                    email: filters?.email ?? "",
                    mobileNumber: filters?.mobileNumber ?? "",
                    upi: filters?.upi ?? "",
                  })
                );
              }}
              onViewMore={(row) => {
                navigate("/risk-management/details", {
                  state: {
                    data: row,
                  },
                });
              }}
              onStatusChange={(val) => {
                if (aclData?.includes(CUSTOMER_STATUS_EDIT)) {
                  onClickChangeStatus(val?.customerId, !val?.status);
                }
              }}
            />
          </div>
        </>
      )}

      {(aclData?.includes(SINGLE_ENTRY) || aclData?.includes(BULK_ENTRY)) &&
        openModal && (
          <CustomModal
            headerTitle="Add Customer"
            open={openModal}
            onClose={() => {
              setOpenModal(false);
              setSingleEntry(true);
            }}
            containerStyle={{
              minWidth: 300,
              maxWidth: 400,
              height: "auto",
              maxHeight: 700,
              //minHeight: 400,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginTop: 25,
                marginBottom: 20,
              }}
            >
              {aclData?.includes(SINGLE_ENTRY) && (
                <>
                  <div
                    onClick={() => {
                      setSingleEntry(true);
                      setbulkfile("");
                    }}
                    style={{
                      fontSize: "18px",
                      fontWeight: 500,
                      color: "#1E2234",
                      cursor: "pointer",
                    }}
                  >
                    Single Entry
                  </div>
                </>
              )}
              {aclData?.includes(BULK_ENTRY) && (
                <>
                  <div
                    onClick={() => {
                      setSingleEntry(false);
                      setCustomerName("");
                      setEmail("");
                      setUpi("");
                      setMobileNumber("");
                      setType("");
                    }}
                    style={{
                      fontSize: "18px",
                      fontWeight: 500,
                      color: "#1E2234",
                      cursor: "pointer",
                    }}
                  >
                    Bulk Entry
                  </div>
                </>
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginTop: 10,
                marginBottom: 15,
              }}
            >
              <div
                style={{
                  height: "4px",
                  background: singleEntry ? "#38369C" : "#FDFDFD",
                  width: "343px",
                }}
              ></div>
              <div
                style={{
                  width: "343px",
                  height: "4px",
                  background: singleEntry ? "#FDFDFD" : "#38369C",
                }}
              ></div>
            </div>
            {aclData?.includes(SINGLE_ENTRY) && singleEntry && (
              <>
                <div
                  style={{
                    overflow: "auto",
                    maxHeight: 400,
                  }}
                >
                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>Customer Name</label>
                    <CustomInput
                      value={customerName}
                      onChange={(data) => setCustomerName(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Customer Name"
                      validator="bankName"
                      type="input"
                      inputStyles={{
                        ...containerStyle,
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>Email</label>
                    <CustomInput
                      value={email}
                      onChange={(data) => setEmail(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Email"
                      validator="email"
                      type="input"
                      inputStyles={{
                        ...containerStyle,
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>Mobile Number</label>
                    <CustomInput
                      value={mobileNumber}
                      onChange={(data) => setMobileNumber(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Mobile Number"
                      validator="mobile"
                      type="input"
                      inputStyles={{
                        ...containerStyle,
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>UPI</label>
                    <CustomInput
                      value={upi}
                      onChange={(data) => setUpi(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="UPI"
                      validator="upi"
                      type="input"
                      inputStyles={{
                        ...containerStyle,
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "343px" }}>
                    <label style={styles.label}>Type</label>
                    <CustomInput
                      value={type}
                      onChange={(data) => setType(data)}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Type"
                      validator="alphaNumeric"
                      type="input"
                      inputStyles={{
                        ...containerStyle,
                      }}
                    />
                  </div>
                  <div
                    style={{
                      marginLeft: "35%",
                    }}
                  >
                    <CustomButton
                      title="Submit"
                      styles={{ background: "#38369C" }}
                      textStyles={{
                        color: "#FDFDFD",
                        fontWeight: "500",
                        fontSize: "16px",
                      }}
                      onClick={() => {
                        if (customerName === "") {
                          enqueueSnackbar("Please enter customer name", {
                            variant: "error",
                          });
                          return;
                        }
                        if (!validateEmail(email)) {
                          enqueueSnackbar("Please enter a valid email", {
                            variant: "error",
                          });
                          return;
                        }
                        if (mobileNumber.length < 10) {
                          enqueueSnackbar(
                            "Please enter a valid mobile number",
                            {
                              variant: "error",
                            }
                          );
                          return;
                        }
                        if (!validateUpi(upi)) {
                          enqueueSnackbar("Please enter valid upi", {
                            variant: "error",
                          });
                          return;
                        }
                        if (type === "") {
                          enqueueSnackbar("Please enter type", {
                            variant: "error",
                          });
                          return;
                        }

                        onClickSingleEntry();
                      }}
                    />
                  </div>
                </div>
              </>
            )}
            {aclData?.includes(BULK_ENTRY) && !singleEntry && (
              <div style={{ maxHeight: 150 }}>
                <div style={{ minWidth: "343px" }}>
                  <p style={styles.docName}>Customer's file</p>
                  <CustomUploadField2
                    document="Customer's file"
                    customIcon={<Upwardarrow />}
                    value={bulkfile}
                    onChange={(data) => {
                      setbulkfile(data);
                    }}
                    onClickRemove={() => {
                      setbulkfile("");
                    }}
                    imageTypeArray={["xlsx"]}
                    accept=".xlsx"
                    filesize={10}
                  />
                  <div
                    style={{
                      display: "flex",
                      margin: "-25px 0 20px 0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      sampleFileDownload();
                    }}
                  >
                    <img
                      src={downloadSym}
                      style={{
                        height: "16px",
                        width: "16px",
                        marginRight: "10px",
                      }}
                    />
                    <p style={{ color: "#38369C", fontSize: "14px" }}>
                      Download sampleFile template
                    </p>
                  </div>
                </div>
                <div style={{ marginLeft: "30%" }}>
                  <CustomButton
                    title="Submit"
                    styles={{ background: "#38369C" }}
                    textStyles={{
                      color: "#FDFDFD",
                      fontWeight: "500",
                      fontSize: "16px",
                    }}
                    onClick={() => {
                      if (!bulkfile) {
                        enqueueSnackbar("Please upload Excel file", {
                          variant: "error",
                        });
                        return;
                      }
                      onClickBulkEntry();
                    }}
                  />
                </div>
              </div>
            )}
          </CustomModal>
        )}
      {openBulkEntryModal && (
        <>
          <CustomModal
            headerTitle="Failed Entries"
            open={openBulkEntryModal}
            onClose={() => {
              setOpenBulkEntryModal(false);
            }}
            containerStyle={{
              minWidth: "70%",
              minHeight: "50%",
            }}
            isConfirmationModalRequired={true}
          >
            <div
              style={{
                height: "70%",
                overflow: "auto",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10,
              }}
            >
              <table
                style={{ width: "100%", paddingRight: "30px" }}
                className="rwd-table"
              >
                <thead className="rwd-table-body">
                  <tr style={{ position: "sticky", top: 0, zIndex: 1 }}>
                    <th>Customer Name</th>
                    <th>Email</th>
                    <th>Mobile Number</th>
                    <th>UPI</th>
                    <th>Type</th>
                    <th>Reason</th>
                  </tr>
                </thead>

                <tbody className="rwd-table-body">
                  {failedCustomersArray[0].map((customer, index) => (
                    <tr key={index}>
                      <td style={{}}>{customer.customerName}</td>
                      <td style={{}}>{customer.email}</td>
                      <td style={{}}>{customer.mobileNumber}</td>
                      <td style={{}}>{customer.upi}</td>
                      <td style={{}}>{customer.type}</td>
                      <td style={styles.reason} class="reason">
                        <span className="tooltip">
                          <FiInfo
                            size={30}
                            className="info-icon"
                            style={{ color: "red" }}
                          />
                          <span className="tooltiptext">{customer.reason}</span>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                position: "relative",
                bottom: 0,
                backgroundColor: "white",
                borderTop: "1px solid black",
                padding: "10px",
              }}
            >
              <p style={{ fontSize: "20px", fontWeight: 600, color: "green" }}>
                Success Count: {successCount}
              </p>
              <p style={{ fontSize: "20px", fontWeight: 600, color: "red" }}>
                Failure Count: {failedCount}
              </p>
            </div>
          </CustomModal>
        </>
      )}
    </div>
  );
};

const styles = {
  label: {
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234",
  },
  reason: {
    color: "blue",
    fontSize: "20px",
    fontWeight: 500,
    padding: "3px",
  },
  reasonDiv: {},
};

export default RiskManagementIndex;
